//snipper animation button loading.

import { Button, Spinner } from "react-bootstrap";

const ButtonSpinner = ({ loading, children, ...props }) => {
  return (
    <Button {...props} disabled={loading}>
      {loading ? (
        <>
          <Spinner
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          {children}
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default ButtonSpinner;
